// extracted by mini-css-extract-plugin
module.exports = {"fully":"layout-module--fully--2OE3m","head":"layout-module--head--3Mhmt","body":"layout-module--body--2dTzP"};